'use strict';

import {
  disabledArrowsAccessibility,
  nextPrevSelectors
} from '../utilities/utility';

$(function() {
  // initialize
  // methods
  function pageLoad() {
    var relatedLength = 0;
    var similarLength = 0;
    $.fn.chunk = function chunk(size) {
      var arr = [];
      $(this)
        .parent()
        .hasClass('related')
        ? (relatedLength += this.length)
        : (similarLength += this.length);
      for (var i = 0; i < this.length; i += size) {
        arr.push(this.slice(i, i + size));
      }
      return this.pushStack(arr, 'chunk', size);
    };

    $('.carousel-mobile.related > .item')
      .chunk(3)
      .wrap('<div class="carousel-slide slide row"></div>');
    $('.carousel-mobile.similar > .item')
      .chunk(3)
      .wrap('<div class="carousel-slide slide row"></div>');

    function resizeRelatedCarousel() {
      var carouselOutterWidth = $('.carousel-mobile-wrapper').innerWidth();
      var newCarouselWidth = ''.concat(carouselOutterWidth, 'px');
      $('.carousel-slide').css({
        'min-width': newCarouselWidth
      });
      var $addToCart = $('#addToCartLayer');
      if ($addToCart.length) {
        carouselOutterWidth = $addToCart
          .find('.carousel-mobile-wrapper')
          .innerWidth();
        newCarouselWidth = ''.concat(carouselOutterWidth, 'px');
        $addToCart.find('.carousel-slide').css({
          'min-width': newCarouselWidth
        });
      }
    }

    function sliderLoaded(slider) {
      $('.bx-clone *').attr('tabindex', '-1');
      $(slider)
        .find('.slide')
        .eq(0)
        .addClass('current');
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
      $(slider)
        .find('.bx-prev')
        .attr('tabindex', '0');
      $(slider)
        .find('.bx-next')
        .attr('tabindex', '0');
      resizeRelatedCarousel();
    }

    function slideBefore(slider, curSlideIndex) {
      $(slider)
        .find('.slide')
        .removeClass('current');
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.slide:not(.bx-clone)')
        .eq(curSlideIndex)
        .addClass('current');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
    }

    function SlideAfter(slider) {
      disabledArrowsAccessibility(slider);
      $(slider)
        .find('.slide')
        .not('.current')
        .find('*')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current')
        .find('a, button')
        .attr('tabindex', '0');
    }

    var sliders = $('.bxslider');
    sliders.each(function(index, element) {
      var options = {
        minSlides: 1,
        maxSlides: 1,
        slideWidth: 900,
        slideMargin: 10,
        responsive: true,
        hideControlOnEnd: true,
        infiniteLoop: false,
        onSliderLoad: sliderLoaded(element),
        onSlideBefore: function onSlideBefore($slideElm, oldIndex, newIndex) {
          slideBefore(element, newIndex);
          $slideElm.attr('data-curSlide', newIndex);
        },
        onSlideAfter: () => {
          SlideAfter(element);
        }
      };

      if ($(element).find('.slide').length === 1) {
        options.pager = false;
      }

      if (window.innerWidth >= 768) {
        options.touchEnabled = false;
        if ($(element).hasClass('related')) {
          nextPrevSelectors('related', options);
        } else if ($(element).hasClass('similar')) {
          nextPrevSelectors('similar', options);
        }
      }
      if ($(element).hasClass('exclusions')) {
        nextPrevSelectors('exclusions', options);
      }
      $(element).bxSlider(options);

      if (relatedLength < 4) {
        $('.related')
          .parents('.bx-wrapper')
          .siblings('.bxslider-carousel__product-icon')
          .hide();
      }
      if (similarLength < 4) {
        $('.similar')
          .parents('.bx-wrapper')
          .siblings('.bxslider-carousel__product-icon')
          .hide();
      }
      disabledArrowsAccessibility(element);
    });
    window.addEventListener('resize', resizeRelatedCarousel); // mutation observer to listen for visibility changes in .modal,
    // fires carousel resize when .modal is visible

    var observer = new MutationObserver(function() {
      resizeRelatedCarousel();
    });
    var target = document.querySelectorAll('.modal')[0];
    if (target != null) {
      observer.observe(target, {
        attributes: true
      });
    }
  }

  pageLoad();
});
